import { createSlice } from "@reduxjs/toolkit";
import { priceInitialState } from "src/models/master_data/price/price.dto";
import { createMsPriceThunk, fetchMsPriceThunk, submitMsPriceThunk, uploadMsPriceThunk } from "../action/price.action";

export const msPriceSlice = createSlice({
    name: 'msPrice',
    initialState: priceInitialState,
    reducers: {},
    extraReducers: (builder) => {

        // Get All Items
        builder
            .addCase(fetchMsPriceThunk.fulfilled, (state, action) => {
                console.log(action.payload)
                state.data = action.payload.data.data;
                state.pagination=action.payload.data.pagination
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(fetchMsPriceThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(fetchMsPriceThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

        // Create Item
        builder
            .addCase(createMsPriceThunk.fulfilled, (state, action) => {
                state.data.push(action.payload.data); 
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(createMsPriceThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(createMsPriceThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

        // Upload Prices
        builder
            .addCase(uploadMsPriceThunk.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(uploadMsPriceThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(uploadMsPriceThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

        // Submit Prices
        builder
            .addCase(submitMsPriceThunk.fulfilled, (state, action) => {
                state.data = action.payload.data; 
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(submitMsPriceThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(submitMsPriceThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

    },
});

export default msPriceSlice.reducer;
